import BaseService from "./BaseService";

export default class DashboardServices extends BaseService {
    public static getDashboardDetails(postData: any, token: string, selectedAccount: string) {
        let url = 'admin/getDashboard?account=' + selectedAccount;
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token

            },
            body: JSON.stringify(postData)
        });
    }

    // Case Dashboard with Search
    public static getCaseDashboardDetails(token: string, postData: any) {
        let url = 'admin/getCaseDashboard';
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }

    // Case Dashboard with Pagination & Search
    public static getPagingCaseDashBoard(token: string, postData: any) {
        let url = 'admin/getPagingCaseDashBoard';
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        });
    }
}